<template>
  <div>
    <div v-if="electionJson['2020Senate']" class="mb-3">
      <b>2020 Senate</b>
      <v-data-table
        class="past-elections-table"
        :headers="pastElectionsHeaders"
        :items="senate2020Data"
        hide-default-footer
        mobile-breakpoint="0">
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.name }}</td>
            <td :style="`${getPartyStyle(item.party.charAt(0))}; width: 25%`">{{ item.party | commas }}</td>
            <td style="width: 20%;">{{ item.votePct * 100 | votePercent }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div v-if="electionJson['2020Presidential']" class="mb-3">
      <b>2020 Presidential</b>
      <v-data-table
        class="past-elections-table"
        :headers="pastElectionsHeaders"
        :items="presidential2020Data"
        hide-default-footer
        mobile-breakpoint="0">
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.name }}</td>
            <td :style="`${getPartyStyle(item.party.charAt(0))}; width: 25%`">{{ item.party | commas }}</td>
            <td style="width: 20%;">{{ item.votePct * 100 | votePercent }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div v-if="electionJson['2018Election']" class="mb-3">
      <b>2018 Results</b>
      <v-data-table
        class="past-elections-table"
        :headers="pastElectionsHeaders"
        :items="pastElectionsData"
        hide-default-footer
        mobile-breakpoint="0">
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.name }}</td>
            <td :style="`${getPartyStyle(item.party.charAt(0))}; width: 25%`">{{ item.party | commas }}</td>
            <td style="width: 20%;">{{ item.votePct * 100 | votePercent }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div v-if="chamber !== 'house'">
      <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
        <b>2016 Presidential</b>
      </div>
      <v-data-table
        class="past-elections-table-2016"
        :headers="presidential2016Headers"
        :items="presidential2016Data
          .filter(i => typeof i === 'object')
          .sort((a, b) => b.count - a.count)"
        hide-default-footer
        mobile-breakpoint="0"
        style="margin-bottom: 30px">
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.candidate }}</td>
            <td :style="`${getPartyStyle(getCandidateParty(item.candidate))}; width: 25%;`">
              {{ getCandidateParty(item.candidate) }}
            </td>
            <td style="width: 20%;">{{ item.pct | votePercent }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
const props = {
  chamber: {
    type: String,
    required: false
  },
  electionJson: {
    type: Object,
    required: true
  }
}

const computed = {
  presidential2016Data () {
    const election = this.electionJson['2016Presidential']
    return Object.values(election)
  },
  pastElectionsData () {
    const data = [...this.electionJson['2018Election']]
    return data.sort((a,b) => b.votePct - a.votePct)
  },
  presidential2020Data() {
    const election = this.electionJson['2020Presidential']
    return Object.values(election)
  },
  senate2020Data() {
    const election = this.electionJson['2020Senate']
    return Object.values(election)
  }
}

const methods = {
  winner (won) {
    if (won) return 'background-color: rgba(87, 174, 166, 0.2);'
  },
  getCandidateParty (name) {
    if (name.includes('Trump')) {
      return 'Republican'
    } else if (name.includes('Clinton')) {
      return 'Democratic'
    } else {
      return 'Other'
    }
  },
  getPartyStyle (party) {
    if (party === 'D' || party === 'Democratic') {
      return 'color: var(--dem); font-weight: 500;'
    } else if (party === 'R' || party === 'Republican') {
      return 'color: var(--gop); font-weight: 500;'
    } else {
      return 'color: var(--green); font-weight: 500;'
    }
  }
}

export default {
  props,
  computed,
  methods,
  data: () => ({
    pastElectionsHeaders: [
      { text: 'Candidate', value: 'name'},
      { text: 'Party', value: 'party' },
      { text: 'Vote %', value: 'votePct' }
    ],
    presidential2016Headers: [
      { text: 'Candidate', value: 'candidate' },
      { text: 'Party', value: 'party' },
      { text: 'Vote %', value: 'pct' }
    ]
  })
}
</script>
